import { LogoMark } from "@/components/branding/LogoMark";
import { formatHijriLong } from "@/domain/hijri/formatHijri";
import { toHijri } from "@/domain/hijri/toHijri";
import { findNextPrayer, formatCountdown } from "@/domain/prayer/nextPrayerCountdown";
import { useDisplaySchedule } from "@/hooks/useDisplaySchedule";
import { useHijriSettings } from "@/hooks/useSettings";
import { useNow } from "@/hooks/useNow";
import { formatIst } from "@/lib/time";

export function ClockHero() {
  const now = useNow(1000);
  const hijriSettings = useHijriSettings();
  const { today, tomorrow } = useDisplaySchedule(now);
  const next = findNextPrayer(today, tomorrow, now);
  const hijri = toHijri(now, hijriSettings.offset);

  return (
    <div className="rounded-card border border-line bg-cream p-6 sm:p-8">
      <div className="text-center">
        <LogoMark className="mx-auto mb-3 h-7 w-auto opacity-90" />
        <div className="label-eyebrow">Now in Dariyapur</div>
        <div className="mt-2 font-serif text-clock tabular-nums text-ink">
          {formatIst(now, "h:mm:ss a")}
        </div>
        <div className="mt-1 text-sm text-muted">
          {formatIst(now, "EEEE, d MMMM yyyy")}
        </div>
        <div className="mt-0.5 text-sm text-masjidGreen">
          {formatHijriLong(hijri)} · {hijri.weekday}
        </div>
      </div>
      <div className="mt-6 border-t border-line pt-5 text-center">
        <div className="label-eyebrow">
          Next Prayer{next.isNextDay ? " · Tomorrow" : ""}
        </div>
        <div className="mt-1 font-serif text-2xl text-masjidGreen">{next.prayer.label}</div>
        <div className="mt-2 font-serif text-countdown tabular-nums text-ink">
          {formatCountdown(next.secondsUntil)}
        </div>
        <div className="mt-1 text-sm text-muted">
          Azaan at {formatIst(next.prayer.azaanTime, "h:mm a")}
        </div>
      </div>
    </div>
  );
}
